import { Formik } from "formik"
import { useState } from "react"
import { ErrorNotification, SuccessNotification } from "../../utils"
import axios from "axios"
import api, { BASE_URL } from "../../utils/api"
import { useForm, SubmitHandler } from "react-hook-form"

const EmailForm = ({ setActiveStep }) => {
  let [passwordloading, setPasswordLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm()


  const onSubmit = async (payload) => {
    setPasswordLoading(true)
    try {
      const { data } = await axios.post(`${BASE_URL}auth/password/requestreset/`, payload)
      if (data) {
        SuccessNotification(data.message || `We’ve sent a 6-digit verification code to ${payload.email}`)
        setPasswordLoading(false)
        localStorage.setItem("email", payload.email)
        setActiveStep(1)
      } else {
        ErrorNotification(data.error)
        setPasswordLoading(false)
      }
    } catch (error) {
      setPasswordLoading(false)
      ErrorNotification(error?.response?.data?.error || error?.message)
    }
  }

  return (
    <div>
      <form
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="my-7">
          <label htmlFor="email" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
            Email<span className="text-red-500">*</span>
          </label>
          <input
            className="w-full font-normal bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400" type="email"
            name="email"
            {...register("email", {
              required: true, pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email address"
              }
            })}
            placeholder="Enter your email"
            required
          />
          {errors.email && (
            <div className="text-red-500 text-sm">{errors.email.message}</div>
          )}
        </div>

        <div className="my-4">
          <button
            disabled={isSubmitting || passwordloading}
            type="submit"
            className="bg-yellowcolor w-full capitalize hover:bg-yellowcolor/90  text-black font-normal py-3 px-10 rounded-md"
          >
            <p>{isSubmitting ? "Please wait..." : "Send Code"} </p>
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmailForm